window.BLOOM_INDIA_PRICE_MAP = {
  "byId": {
    "48242795643017": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48355182575753": {
      "price": 764.0,
      "compare": 899.0,
      "source": "biogetica"
    },
    "48355182608521": {
      "price": 1348.0,
      "compare": 1798.0,
      "source": "biogetica"
    },
    "48363050303625": {
      "price": 2157.0,
      "compare": 3596.0,
      "source": "biogetica"
    },
    "48363817140361": {
      "price": 849.0,
      "compare": 999.0,
      "source": "biogetica"
    },
    "48368643899529": {
      "price": 1498.0,
      "compare": 1998.0,
      "source": "biogetica"
    },
    "48363817205897": {
      "price": 2397.0,
      "compare": 3996.0,
      "source": "biogetica"
    },
    "48242795413641": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242795380873": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242795348105": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242795249801": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242795217033": {
      "price": 899.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242795184265": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242795151497": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242795118729": {
      "price": 1299.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242795085961": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242795020425": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242795053193": {
      "price": 899.0,
      "compare": 999.0,
      "source": "biogetica"
    },
    "48242794987657": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794889353": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794856585": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794823817": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794791049": {
      "price": 1299.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794758281": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794692745": {
      "price": 899.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794725513": {
      "price": 1499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48364191285385": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48364189679753": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "48364189712521": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "48364189745289": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "48242794561673": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794594441": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "48364290670729": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "48364290703497": {
      "price": 3198.0,
      "compare": 3998.0,
      "source": "biogetica"
    },
    "48364290736265": {
      "price": 5997.0,
      "compare": 7996.0,
      "source": "biogetica"
    },
    "48368644128905": {
      "price": 1274.0,
      "compare": 1499.0,
      "source": "biogetica"
    },
    "48368644161673": {
      "price": 2248.0,
      "compare": 2998.0,
      "source": "biogetica"
    },
    "48368644194441": {
      "price": 3597.0,
      "compare": 5996.0,
      "source": "biogetica"
    },
    "48242794430601": {
      "price": 1299.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794365065": {
      "price": 299.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794397833": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242792530057": {
      "price": 1499.0,
      "compare": 3498.0,
      "source": "biogetica"
    },
    "48368705601673": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "48368705634441": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "48242794266761": {
      "price": 2399.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794201225": {
      "price": 1299.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794168457": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794135689": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794004617": {
      "price": 299.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242794037385": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48243194200201": {
      "price": 399.0,
      "compare": null,
      "source": "biogetica"
    },
    "48243194232969": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "48243194265737": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48368701800585": {
      "price": 1898.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793873545": {
      "price": 1499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793840777": {
      "price": 1399.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793808009": {
      "price": 899.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793775241": {
      "price": 1499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793742473": {
      "price": 1099.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793709705": {
      "price": 1399.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793611401": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793578633": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793545865": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793513097": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793480329": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793447561": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793414793": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793382025": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793283721": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793250953": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793218185": {
      "price": 4888.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793185417": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793152649": {
      "price": 4888.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793119881": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793087113": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793054345": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242793021577": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242792923273": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242792890505": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242792857737": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242792824969": {
      "price": 6499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242792792201": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242792726665": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242792693897": {
      "price": 6499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242792661129": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242773491849": {
      "price": 6499.0,
      "compare": 7148.0,
      "source": "biogetica"
    },
    "48242772607113": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242783027337": {
      "price": 7197.0,
      "compare": 7997.0,
      "source": "biogetica"
    },
    "48242783060105": {
      "price": 13594.0,
      "compare": 15994.0,
      "source": "biogetica"
    },
    "48242783092873": {
      "price": 26230.0,
      "compare": 31988.0,
      "source": "biogetica"
    },
    "48355593552009": {
      "price": 1797.3,
      "compare": 1997.0,
      "source": "biogetica"
    },
    "48355593584777": {
      "price": 7192.8,
      "compare": 9892.8,
      "source": "biogetica"
    },
    "48355593617545": {
      "price": 17027.0,
      "compare": 18918.21,
      "source": "biogetica"
    },
    "48242782732425": {
      "price": 6747.0,
      "compare": 7497.0,
      "source": "biogetica"
    },
    "48242782765193": {
      "price": 12744.0,
      "compare": 14994.0,
      "source": "biogetica"
    },
    "48242782797961": {
      "price": 24590.0,
      "compare": 29988.0,
      "source": "biogetica"
    },
    "48242771230857": {
      "price": 5195.0,
      "compare": 5773.0,
      "source": "biogetica"
    },
    "48242771263625": {
      "price": 10168.0,
      "compare": 11546.0,
      "source": "biogetica"
    },
    "48242771296393": {
      "price": 19859.0,
      "compare": 23092.0,
      "source": "biogetica"
    },
    "48242771132553": {
      "price": 4590.0,
      "compare": 5216.0,
      "source": "biogetica"
    },
    "48242771165321": {
      "price": 8867.0,
      "compare": 10432.0,
      "source": "biogetica"
    },
    "48242771198089": {
      "price": 16899.0,
      "compare": 20864.0,
      "source": "biogetica"
    },
    "48242779259017": {
      "price": 3146.0,
      "compare": 3496.0,
      "source": "biogetica"
    },
    "48242779291785": {
      "price": 5943.0,
      "compare": 6992.0,
      "source": "biogetica"
    },
    "48242779324553": {
      "price": 11187.0,
      "compare": 13984.0,
      "source": "biogetica"
    },
    "48242770968713": {
      "price": 5037.0,
      "compare": 5597.0,
      "source": "biogetica"
    },
    "48242771001481": {
      "price": 9514.0,
      "compare": 11194.0,
      "source": "biogetica"
    },
    "48242771034249": {
      "price": 17910.0,
      "compare": 22388.0,
      "source": "biogetica"
    },
    "48242775556233": {
      "price": 4227.3,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "48242775589001": {
      "price": 8107.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "48242775621769": {
      "price": 15383.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "48242783125641": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242783158409": {
      "price": 9674.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242783191177": {
      "price": 18689.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48355802939529": {
      "price": 4767.3,
      "compare": 5797.0,
      "source": "biogetica"
    },
    "48355802972297": {
      "price": 9854.0,
      "compare": 11594.0,
      "source": "biogetica"
    },
    "48355803005065": {
      "price": 17026.38,
      "compare": 23188.0,
      "source": "biogetica"
    },
    "48242770870409": {
      "price": 8092.0,
      "compare": 9196.0,
      "source": "biogetica"
    },
    "48242770903177": {
      "price": 15633.0,
      "compare": 18392.0,
      "source": "biogetica"
    },
    "48242770935945": {
      "price": 30162.0,
      "compare": 36784.0,
      "source": "biogetica"
    },
    "48242770772105": {
      "price": 4227.3,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "48242770804873": {
      "price": 8107.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "48242770837641": {
      "price": 15383.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "48242782929033": {
      "price": 3996.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242782961801": {
      "price": 7192.8,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242782994569": {
      "price": 18918.21,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242782830729": {
      "price": 4837.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242782863497": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242782896265": {
      "price": 18030.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242770673801": {
      "price": 4813.2,
      "compare": 5162.0,
      "source": "biogetica"
    },
    "48242770706569": {
      "price": 10194.0,
      "compare": 11994.0,
      "source": "biogetica"
    },
    "48242770739337": {
      "price": 19190.0,
      "compare": 23988.0,
      "source": "biogetica"
    },
    "48242782568585": {
      "price": 5457.0,
      "compare": 6497.0,
      "source": "biogetica"
    },
    "48242782601353": {
      "price": 10395.0,
      "compare": 12994.0,
      "source": "biogetica"
    },
    "48242782634121": {
      "price": 19750.0,
      "compare": 25988.0,
      "source": "biogetica"
    },
    "48242782470281": {
      "price": 2697.0,
      "compare": 2997.0,
      "source": "biogetica"
    },
    "48242782503049": {
      "price": 5274.0,
      "compare": 5994.0,
      "source": "biogetica"
    },
    "48242782535817": {
      "price": 10309.0,
      "compare": 11988.0,
      "source": "biogetica"
    },
    "48242770575497": {
      "price": 5012.0,
      "compare": 5696.0,
      "source": "biogetica"
    },
    "48242770608265": {
      "price": 9569.0,
      "compare": 11392.0,
      "source": "biogetica"
    },
    "48242770641033": {
      "price": 18227.0,
      "compare": 22784.0,
      "source": "biogetica"
    },
    "48242770477193": {
      "price": 4066.0,
      "compare": 4621.0,
      "source": "biogetica"
    },
    "48242770509961": {
      "price": 7763.0,
      "compare": 9242.0,
      "source": "biogetica"
    },
    "48242770542729": {
      "price": 14787.0,
      "compare": 18484.0,
      "source": "biogetica"
    },
    "48242782142601": {
      "price": 4573.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "48242782175369": {
      "price": 8730.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "48242782208137": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "48242782371977": {
      "price": 5101.0,
      "compare": 5797.0,
      "source": "biogetica"
    },
    "48242782404745": {
      "price": 9738.0,
      "compare": 11594.0,
      "source": "biogetica"
    },
    "48242782437513": {
      "price": 18550.0,
      "compare": 23188.0,
      "source": "biogetica"
    },
    "48242782273673": {
      "price": 4397.0,
      "compare": 4997.0,
      "source": "biogetica"
    },
    "48242782306441": {
      "price": 8394.0,
      "compare": 9994.0,
      "source": "biogetica"
    },
    "48242782339209": {
      "price": 15990.0,
      "compare": 19988.0,
      "source": "biogetica"
    },
    "48242782044297": {
      "price": 2697.0,
      "compare": 2997.0,
      "source": "biogetica"
    },
    "48242782077065": {
      "price": 5154.0,
      "compare": 5994.0,
      "source": "biogetica"
    },
    "48242782109833": {
      "price": 9830.0,
      "compare": 11988.0,
      "source": "biogetica"
    },
    "48242770247817": {
      "price": 3597.0,
      "compare": 3997.0,
      "source": "biogetica"
    },
    "48242770280585": {
      "price": 6794.0,
      "compare": 7994.0,
      "source": "biogetica"
    },
    "48242770313353": {
      "price": 12790.0,
      "compare": 15988.0,
      "source": "biogetica"
    },
    "48242781585545": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242781618313": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242781651081": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242770149513": {
      "price": 5782.0,
      "compare": 6497.0,
      "source": "biogetica"
    },
    "48242770182281": {
      "price": 10914.0,
      "compare": 12994.0,
      "source": "biogetica"
    },
    "48242770215049": {
      "price": 20530.0,
      "compare": 25988.0,
      "source": "biogetica"
    },
    "48242777129097": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "48242777161865": {
      "price": 8938.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "48242777194633": {
      "price": 17046.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "48242781847689": {
      "price": 5846.0,
      "compare": 6496.0,
      "source": "biogetica"
    },
    "48242781880457": {
      "price": 11043.0,
      "compare": 12992.0,
      "source": "biogetica"
    },
    "48242781913225": {
      "price": 20787.0,
      "compare": 25984.0,
      "source": "biogetica"
    },
    "48242770051209": {
      "price": 4925.0,
      "compare": 5597.0,
      "source": "biogetica"
    },
    "48242770083977": {
      "price": 9291.0,
      "compare": 11194.0,
      "source": "biogetica"
    },
    "48242770116745": {
      "price": 17462.0,
      "compare": 22388.0,
      "source": "biogetica"
    },
    "48242781388937": {
      "price": 3077.0,
      "compare": 3497.0,
      "source": "biogetica"
    },
    "48242781421705": {
      "price": 5805.0,
      "compare": 6994.0,
      "source": "biogetica"
    },
    "48242781454473": {
      "price": 10910.0,
      "compare": 13988.0,
      "source": "biogetica"
    },
    "48242769952905": {
      "price": 4645.0,
      "compare": 5162.0,
      "source": "biogetica"
    },
    "48242769985673": {
      "price": 8775.0,
      "compare": 10324.0,
      "source": "biogetica"
    },
    "48242770018441": {
      "price": 16518.0,
      "compare": 20648.0,
      "source": "biogetica"
    },
    "48242769854601": {
      "price": 4651.0,
      "compare": 5168.0,
      "source": "biogetica"
    },
    "48242769887369": {
      "price": 8785.0,
      "compare": 10336.0,
      "source": "biogetica"
    },
    "48242769920137": {
      "price": 16537.0,
      "compare": 20672.0,
      "source": "biogetica"
    },
    "48242769756297": {
      "price": 898.0,
      "compare": 998.0,
      "source": "biogetica"
    },
    "48242781945993": {
      "price": 5457.0,
      "compare": 6497.0,
      "source": "biogetica"
    },
    "48242781978761": {
      "price": 10395.0,
      "compare": 12994.0,
      "source": "biogetica"
    },
    "48242782011529": {
      "price": 19750.0,
      "compare": 25988.0,
      "source": "biogetica"
    },
    "48242781683849": {
      "price": 4497.0,
      "compare": 4997.0,
      "source": "biogetica"
    },
    "48242781716617": {
      "price": 8494.0,
      "compare": 9994.0,
      "source": "biogetica"
    },
    "48242781749385": {
      "price": 15990.0,
      "compare": 19988.0,
      "source": "biogetica"
    },
    "48242781487241": {
      "price": 5130.0,
      "compare": 5897.0,
      "source": "biogetica"
    },
    "48242781520009": {
      "price": 9671.0,
      "compare": 11794.0,
      "source": "biogetica"
    },
    "48242781552777": {
      "price": 18162.0,
      "compare": 23588.0,
      "source": "biogetica"
    },
    "48242769657993": {
      "price": 4178.0,
      "compare": 4643.0,
      "source": "biogetica"
    },
    "48242769690761": {
      "price": 7893.0,
      "compare": 9286.0,
      "source": "biogetica"
    },
    "48242769723529": {
      "price": 14857.0,
      "compare": 18572.0,
      "source": "biogetica"
    },
    "48242780995721": {
      "price": 5037.0,
      "compare": 5597.0,
      "source": "biogetica"
    },
    "48242781028489": {
      "price": 9514.0,
      "compare": 11194.0,
      "source": "biogetica"
    },
    "48242781061257": {
      "price": 17910.0,
      "compare": 22388.0,
      "source": "biogetica"
    },
    "48242781290633": {
      "price": 4122.0,
      "compare": 4580.0,
      "source": "biogetica"
    },
    "48242781323401": {
      "price": 7786.0,
      "compare": 9160.0,
      "source": "biogetica"
    },
    "48242781356169": {
      "price": 14656.0,
      "compare": 18320.0,
      "source": "biogetica"
    },
    "48242781192329": {
      "price": 7647.0,
      "compare": 8497.0,
      "source": "biogetica"
    },
    "48242781225097": {
      "price": 14444.0,
      "compare": 16994.0,
      "source": "biogetica"
    },
    "48242781257865": {
      "price": 27190.0,
      "compare": 33988.0,
      "source": "biogetica"
    },
    "48356705534089": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48356705566857": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48356705599625": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242781094025": {
      "price": 5307.0,
      "compare": 5897.0,
      "source": "biogetica"
    },
    "48242781126793": {
      "price": 10024.0,
      "compare": 11794.0,
      "source": "biogetica"
    },
    "48242781159561": {
      "price": 18870.0,
      "compare": 23588.0,
      "source": "biogetica"
    },
    "48242769494153": {
      "price": 3147.0,
      "compare": 3497.0,
      "source": "biogetica"
    },
    "48242769526921": {
      "price": 5944.0,
      "compare": 6994.0,
      "source": "biogetica"
    },
    "48242769559689": {
      "price": 11190.0,
      "compare": 13988.0,
      "source": "biogetica"
    },
    "48242769395849": {
      "price": 5013.0,
      "compare": 5571.0,
      "source": "biogetica"
    },
    "48242769428617": {
      "price": 9470.0,
      "compare": 11142.0,
      "source": "biogetica"
    },
    "48242769461385": {
      "price": 17827.0,
      "compare": 22284.0,
      "source": "biogetica"
    },
    "48242776440969": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242776473737": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242776506505": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242780831881": {
      "price": 1707.0,
      "compare": 1897.0,
      "source": "biogetica"
    },
    "48242780864649": {
      "price": 3224.0,
      "compare": 3794.0,
      "source": "biogetica"
    },
    "48242780897417": {
      "price": 6070.0,
      "compare": 7588.0,
      "source": "biogetica"
    },
    "48242780733577": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "48242780766345": {
      "price": 8834.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "48242780799113": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "48242780635273": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242780668041": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242780700809": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242769297545": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242769330313": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242769363081": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242779685001": {
      "price": 2608.0,
      "compare": 2898.0,
      "source": "biogetica"
    },
    "48242779717769": {
      "price": 4926.0,
      "compare": 5796.0,
      "source": "biogetica"
    },
    "48242779750537": {
      "price": 9273.0,
      "compare": 11592.0,
      "source": "biogetica"
    },
    "48242779553929": {
      "price": 4946.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242779586697": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242779619465": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242779357321": {
      "price": 7647.0,
      "compare": 8497.0,
      "source": "biogetica"
    },
    "48242779390089": {
      "price": 14444.0,
      "compare": 16994.0,
      "source": "biogetica"
    },
    "48242779422857": {
      "price": 27190.0,
      "compare": 33988.0,
      "source": "biogetica"
    },
    "48242769199241": {
      "price": 2322.0,
      "compare": 2580.0,
      "source": "biogetica"
    },
    "48242769232009": {
      "price": 4386.0,
      "compare": 5160.0,
      "source": "biogetica"
    },
    "48242769264777": {
      "price": 8256.0,
      "compare": 10320.0,
      "source": "biogetica"
    },
    "48242769100937": {
      "price": 4372.0,
      "compare": 4858.0,
      "source": "biogetica"
    },
    "48242769133705": {
      "price": 8258.0,
      "compare": 9716.0,
      "source": "biogetica"
    },
    "48242769166473": {
      "price": 15545.0,
      "compare": 19432.0,
      "source": "biogetica"
    },
    "48242779455625": {
      "price": 5846.0,
      "compare": 6496.0,
      "source": "biogetica"
    },
    "48242779488393": {
      "price": 11043.0,
      "compare": 12992.0,
      "source": "biogetica"
    },
    "48242779521161": {
      "price": 20787.0,
      "compare": 25984.0,
      "source": "biogetica"
    },
    "48242777981065": {
      "price": 3900.0,
      "compare": 4196.0,
      "source": "biogetica"
    },
    "48242778046601": {
      "price": 3900.0,
      "compare": 4196.0,
      "source": "biogetica"
    },
    "48242769002633": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "48242769035401": {
      "price": 8834.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "48242769068169": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "48242778996873": {
      "price": 3996.0,
      "compare": 4996.0,
      "source": "biogetica"
    },
    "48242779029641": {
      "price": 7192.8,
      "compare": 9992.0,
      "source": "biogetica"
    },
    "48242779062409": {
      "price": 13988.0,
      "compare": 19984.0,
      "source": "biogetica"
    },
    "48242768904329": {
      "price": 6296.0,
      "compare": 6996.0,
      "source": "biogetica"
    },
    "48242768937097": {
      "price": 11893.0,
      "compare": 13992.0,
      "source": "biogetica"
    },
    "48242768969865": {
      "price": 22387.0,
      "compare": 27984.0,
      "source": "biogetica"
    },
    "48242778865801": {
      "price": 4127.0,
      "compare": 4586.0,
      "source": "biogetica"
    },
    "48242778898569": {
      "price": 7796.0,
      "compare": 9172.0,
      "source": "biogetica"
    },
    "48242778931337": {
      "price": 14675.0,
      "compare": 18344.0,
      "source": "biogetica"
    },
    "48242768806025": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242768838793": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242768871561": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242779160713": {
      "price": 5047.0,
      "compare": 5608.0,
      "source": "biogetica"
    },
    "48242779193481": {
      "price": 9533.0,
      "compare": 11216.0,
      "source": "biogetica"
    },
    "48242779226249": {
      "price": 17945.0,
      "compare": 22432.0,
      "source": "biogetica"
    },
    "48242768707721": {
      "price": 5126.0,
      "compare": 5696.0,
      "source": "biogetica"
    },
    "48242768740489": {
      "price": 9683.0,
      "compare": 11392.0,
      "source": "biogetica"
    },
    "48242768773257": {
      "price": 18227.0,
      "compare": 22784.0,
      "source": "biogetica"
    },
    "48242777882761": {
      "price": 4047.0,
      "compare": 4497.0,
      "source": "biogetica"
    },
    "48242777915529": {
      "price": 7644.0,
      "compare": 8994.0,
      "source": "biogetica"
    },
    "48242777948297": {
      "price": 14390.0,
      "compare": 17988.0,
      "source": "biogetica"
    },
    "48242777784457": {
      "price": 5217.0,
      "compare": 5797.0,
      "source": "biogetica"
    },
    "48242777817225": {
      "price": 9854.0,
      "compare": 11594.0,
      "source": "biogetica"
    },
    "48242777849993": {
      "price": 18550.0,
      "compare": 23188.0,
      "source": "biogetica"
    },
    "48242768609417": {
      "price": 5037.0,
      "compare": 5597.0,
      "source": "biogetica"
    },
    "48242768642185": {
      "price": 9514.0,
      "compare": 11194.0,
      "source": "biogetica"
    },
    "48242768674953": {
      "price": 17910.0,
      "compare": 22388.0,
      "source": "biogetica"
    },
    "48242768511113": {
      "price": 4857.0,
      "compare": 5397.0,
      "source": "biogetica"
    },
    "48242768543881": {
      "price": 9174.0,
      "compare": 10794.0,
      "source": "biogetica"
    },
    "48242768576649": {
      "price": 17270.0,
      "compare": 21588.0,
      "source": "biogetica"
    },
    "48242777686153": {
      "price": 1258.0,
      "compare": 1398.0,
      "source": "biogetica"
    },
    "48242777718921": {
      "price": 2376.0,
      "compare": 2796.0,
      "source": "biogetica"
    },
    "48242777751689": {
      "price": 4473.0,
      "compare": 5592.0,
      "source": "biogetica"
    },
    "48242777587849": {
      "price": 2697.0,
      "compare": 2997.0,
      "source": "biogetica"
    },
    "48242777620617": {
      "price": 5094.0,
      "compare": 5994.0,
      "source": "biogetica"
    },
    "48242777653385": {
      "price": 9590.0,
      "compare": 11988.0,
      "source": "biogetica"
    },
    "48242777489545": {
      "price": 5307.0,
      "compare": 5897.0,
      "source": "biogetica"
    },
    "48242777522313": {
      "price": 10024.0,
      "compare": 11794.0,
      "source": "biogetica"
    },
    "48242777555081": {
      "price": 18870.0,
      "compare": 23588.0,
      "source": "biogetica"
    },
    "48242777325705": {
      "price": 4496.0,
      "compare": 4996.0,
      "source": "biogetica"
    },
    "48242777358473": {
      "price": 8493.0,
      "compare": 9992.0,
      "source": "biogetica"
    },
    "48242777391241": {
      "price": 15987.0,
      "compare": 19984.0,
      "source": "biogetica"
    },
    "48242777227401": {
      "price": 7646.0,
      "compare": 8496.0,
      "source": "biogetica"
    },
    "48242777260169": {
      "price": 14443.0,
      "compare": 16992.0,
      "source": "biogetica"
    },
    "48242777292937": {
      "price": 27187.0,
      "compare": 33984.0,
      "source": "biogetica"
    },
    "48242768412809": {
      "price": 8133.0,
      "compare": 9037.0,
      "source": "biogetica"
    },
    "48242768445577": {
      "price": 15362.0,
      "compare": 18074.0,
      "source": "biogetica"
    },
    "48242768478345": {
      "price": 28918.0,
      "compare": 36148.0,
      "source": "biogetica"
    },
    "48242768248969": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242768281737": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242768314505": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242768150665": {
      "price": 3597.0,
      "compare": 3997.0,
      "source": "biogetica"
    },
    "48242768183433": {
      "price": 6794.0,
      "compare": 7994.0,
      "source": "biogetica"
    },
    "48242768216201": {
      "price": 12790.0,
      "compare": 15988.0,
      "source": "biogetica"
    },
    "48242777063561": {
      "price": 14148.59,
      "compare": null,
      "source": "biogetica"
    },
    "48242768052361": {
      "price": 4642.0,
      "compare": 5158.0,
      "source": "biogetica"
    },
    "48242768085129": {
      "price": 8768.0,
      "compare": 10316.0,
      "source": "biogetica"
    },
    "48242768117897": {
      "price": 16505.0,
      "compare": 20632.0,
      "source": "biogetica"
    },
    "48242767954057": {
      "price": 5037.0,
      "compare": 5597.0,
      "source": "biogetica"
    },
    "48242767986825": {
      "price": 9514.0,
      "compare": 11194.0,
      "source": "biogetica"
    },
    "48242768019593": {
      "price": 17910.0,
      "compare": 22388.0,
      "source": "biogetica"
    },
    "48242776932489": {
      "price": 5473.0,
      "compare": 6082.0,
      "source": "biogetica"
    },
    "48242776965257": {
      "price": 10339.0,
      "compare": 12164.0,
      "source": "biogetica"
    },
    "48242776998025": {
      "price": 19462.0,
      "compare": 24328.0,
      "source": "biogetica"
    },
    "48242776834185": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242776866953": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242776899721": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242776735881": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "48242776768649": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "48242776801417": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "48242776277129": {
      "price": 8546.0,
      "compare": 9496.0,
      "source": "biogetica"
    },
    "48242776309897": {
      "price": 16143.0,
      "compare": 18992.0,
      "source": "biogetica"
    },
    "48242776342665": {
      "price": 30387.0,
      "compare": 37984.0,
      "source": "biogetica"
    },
    "48242767855753": {
      "price": 4448.0,
      "compare": 4943.0,
      "source": "biogetica"
    },
    "48242767888521": {
      "price": 8403.0,
      "compare": 9886.0,
      "source": "biogetica"
    },
    "48242767921289": {
      "price": 15817.0,
      "compare": 19772.0,
      "source": "biogetica"
    },
    "48242767691913": {
      "price": 729.0,
      "compare": 1020.0,
      "source": "biogetica"
    },
    "48242767724681": {
      "price": 1455.0,
      "compare": 2040.0,
      "source": "biogetica"
    },
    "48242767757449": {
      "price": 2910.0,
      "compare": 4080.0,
      "source": "biogetica"
    },
    "48242767560841": {
      "price": 6298.0,
      "compare": 6998.0,
      "source": "biogetica"
    },
    "48242767593609": {
      "price": 11896.0,
      "compare": 13996.0,
      "source": "biogetica"
    },
    "48242767626377": {
      "price": 22953.0,
      "compare": 27992.0,
      "source": "biogetica"
    },
    "48242776178825": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "48242776211593": {
      "price": 8834.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "48242776244361": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "48242767462537": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "48242767495305": {
      "price": 8834.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "48242767528073": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "48242776047753": {
      "price": 3686.0,
      "compare": 4096.0,
      "source": "biogetica"
    },
    "48242776080521": {
      "price": 6963.0,
      "compare": 8192.0,
      "source": "biogetica"
    },
    "48242776113289": {
      "price": 13107.0,
      "compare": 16384.0,
      "source": "biogetica"
    },
    "48242767364233": {
      "price": 4439.0,
      "compare": 4933.0,
      "source": "biogetica"
    },
    "48242767397001": {
      "price": 8386.0,
      "compare": 9866.0,
      "source": "biogetica"
    },
    "48242767429769": {
      "price": 15785.0,
      "compare": 19732.0,
      "source": "biogetica"
    },
    "48242767265929": {
      "price": 2248.0,
      "compare": 2498.0,
      "source": "biogetica"
    },
    "48242767298697": {
      "price": 4246.0,
      "compare": 4996.0,
      "source": "biogetica"
    },
    "48242767331465": {
      "price": 7993.0,
      "compare": 9992.0,
      "source": "biogetica"
    },
    "48242775949449": {
      "price": 4497.0,
      "compare": 4997.0,
      "source": "biogetica"
    },
    "48242775982217": {
      "price": 8494.0,
      "compare": 9994.0,
      "source": "biogetica"
    },
    "48242776014985": {
      "price": 15990.0,
      "compare": 19988.0,
      "source": "biogetica"
    },
    "48242775851145": {
      "price": 2877.0,
      "compare": 3197.0,
      "source": "biogetica"
    },
    "48242775883913": {
      "price": 5434.0,
      "compare": 6394.0,
      "source": "biogetica"
    },
    "48242775916681": {
      "price": 10230.0,
      "compare": 12788.0,
      "source": "biogetica"
    },
    "48242792431753": {
      "price": 3996.0,
      "compare": 4496.0,
      "source": "biogetica"
    },
    "48242792464521": {
      "price": 7192.8,
      "compare": 8992.0,
      "source": "biogetica"
    },
    "48242792497289": {
      "price": 13488.0,
      "compare": 17984.0,
      "source": "biogetica"
    },
    "48242775457929": {
      "price": 5756.0,
      "compare": 6396.0,
      "source": "biogetica"
    },
    "48242775490697": {
      "price": 10873.0,
      "compare": 12792.0,
      "source": "biogetica"
    },
    "48242775523465": {
      "price": 20467.0,
      "compare": 25584.0,
      "source": "biogetica"
    },
    "48242767003785": {
      "price": 11427.0,
      "compare": 12697.0,
      "source": "biogetica"
    },
    "48242767036553": {
      "price": 21584.0,
      "compare": 25394.0,
      "source": "biogetica"
    },
    "48242767069321": {
      "price": 40630.0,
      "compare": 50788.0,
      "source": "biogetica"
    },
    "48242775359625": {
      "price": 5847.0,
      "compare": 6497.0,
      "source": "biogetica"
    },
    "48242775392393": {
      "price": 11044.0,
      "compare": 12994.0,
      "source": "biogetica"
    },
    "48242775425161": {
      "price": 20790.0,
      "compare": 25988.0,
      "source": "biogetica"
    },
    "48242775195785": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "48242775228553": {
      "price": 8834.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "48242775261321": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "48242775097481": {
      "price": 1527.0,
      "compare": 1697.0,
      "source": "biogetica"
    },
    "48242775130249": {
      "price": 2986.0,
      "compare": 3394.0,
      "source": "biogetica"
    },
    "48242775163017": {
      "price": 5769.0,
      "compare": 6788.0,
      "source": "biogetica"
    },
    "48242766905481": {
      "price": 4889.0,
      "compare": 5433.0,
      "source": "biogetica"
    },
    "48242766938249": {
      "price": 9236.0,
      "compare": 10866.0,
      "source": "biogetica"
    },
    "48242766971017": {
      "price": 17385.0,
      "compare": 21732.0,
      "source": "biogetica"
    },
    "48242766807177": {
      "price": 4048.0,
      "compare": 4498.0,
      "source": "biogetica"
    },
    "48242766839945": {
      "price": 7646.0,
      "compare": 8996.0,
      "source": "biogetica"
    },
    "48242766872713": {
      "price": 14393.0,
      "compare": 17992.0,
      "source": "biogetica"
    },
    "48242788466825": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242788401289": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242788368521": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242788335753": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242788302985": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242788270217": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242788237449": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242788139145": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242788106377": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787778697": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787713161": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774442121": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787680393": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242771787913": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787647625": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242771689609": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787582089": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787549321": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787516553": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787418249": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787319945": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787254409": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787221641": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787188873": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787156105": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242787123337": {
      "price": 3736.4,
      "compare": null,
      "source": "biogetica"
    },
    "48242787090569": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242786926729": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242786795657": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242786762889": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242771656841": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242786730121": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242786697353": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242785550473": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242785484937": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242785452169": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242785386633": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242785353865": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242784731273": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242784600201": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242784567433": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242784534665": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242784501897": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242784469129": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242784436361": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242783617161": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242783584393": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242783486089": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242783453321": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242771591305": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242783420553": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242771558537": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242772541577": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242792398985": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242792366217": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242792333449": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242792300681": {
      "price": 4462.98,
      "compare": null,
      "source": "biogetica"
    },
    "48242792267913": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242792235145": {
      "price": 4462.98,
      "compare": null,
      "source": "biogetica"
    },
    "48242792202377": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242792104073": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242792071305": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242792038537": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242792005769": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791973001": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791350409": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791940233": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791907465": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791874697": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791776393": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791743625": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791710857": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791678089": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791645321": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791612553": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791579785": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791547017": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791514249": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791383177": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242791317641": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789908617": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789875849": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789843081": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789810313": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789777545": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789744777": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789712009": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789613705": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789580937": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242772181129": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789548169": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789515401": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242772115593": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789286025": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789253257": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789220489": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789187721": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789154953": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242772017289": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242771984521": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242789056649": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242771918985": {
      "price": 4694.45,
      "compare": null,
      "source": "biogetica"
    },
    "48242789023881": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242788991113": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242788761737": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242788728969": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242788696201": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242771853449": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242788663433": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48242788630665": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "48454077939849": {
      "price": 3996.0,
      "compare": 5496.0,
      "source": "biogetica"
    },
    "48454077972617": {
      "price": 7192.8,
      "compare": 9892.8,
      "source": "biogetica"
    },
    "48454078005385": {
      "price": 20446.0,
      "compare": 22717.04,
      "source": "biogetica"
    },
    "48242774900873": {
      "price": 1797.3,
      "compare": 1997.0,
      "source": "biogetica"
    },
    "48242774868105": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774605961": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48430092583049": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48430415577225": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "48430415609993": {
      "price": 2998.0,
      "compare": 3998.0,
      "source": "biogetica"
    },
    "48430415642761": {
      "price": 4797.0,
      "compare": 7996.0,
      "source": "biogetica"
    },
    "48430416330889": {
      "price": 1797.3,
      "compare": 1997.0,
      "source": "biogetica"
    },
    "48368642523273": {
      "price": 1499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774179977": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774769801": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774114441": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774737033": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774573193": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48430416822409": {
      "price": 3900.0,
      "compare": 4196.0,
      "source": "biogetica"
    },
    "48368744693897": {
      "price": 8137.0,
      "compare": 9042.0,
      "source": "biogetica"
    },
    "48242774999177": {
      "price": 5014.0,
      "compare": 5572.0,
      "source": "biogetica"
    },
    "48242774409353": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242767167625": {
      "price": 3996.0,
      "compare": 4496.0,
      "source": "biogetica"
    },
    "48242792562825": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "48242784632969": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242773852297": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48364299878537": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774147209": {
      "price": 3736.4,
      "compare": null,
      "source": "biogetica"
    },
    "48242774081673": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774343817": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774212745": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774016137": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774540425": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774638729": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774474889": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242773983369": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774835337": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774802569": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242773786761": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242773885065": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242773819529": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242773655689": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242774311049": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242773557385": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "48242773524617": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    }
  },
  "byHandleVariant": {
    "biogetica-thermogenix-garcinia-ayurvedic-fat-loss-products-for-men-women-fat-burner-appetite-suppressant-80-tablets|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-spiruliva-for-nutrition-that-crosses-the-blood-brain-barrier-80-capsules|40 days": {
      "price": 764.0,
      "compare": 899.0,
      "source": "biogetica"
    },
    "biogetica-spiruliva-for-nutrition-that-crosses-the-blood-brain-barrier-80-capsules|80 days": {
      "price": 1348.0,
      "compare": 1798.0,
      "source": "biogetica"
    },
    "biogetica-spiruliva-for-nutrition-that-crosses-the-blood-brain-barrier-80-capsules|160 days": {
      "price": 2157.0,
      "compare": 3596.0,
      "source": "biogetica"
    },
    "biogetica-pranavita-green-balanced-green-drink-superfood-complex-packed-with-vitamins-and-micro-nutrients-naturally-anti-aging-3-5-oz-100-gm|40 days": {
      "price": 849.0,
      "compare": 999.0,
      "source": "biogetica"
    },
    "biogetica-pranavita-green-balanced-green-drink-superfood-complex-packed-with-vitamins-and-micro-nutrients-naturally-anti-aging-3-5-oz-100-gm|80 days": {
      "price": 1498.0,
      "compare": 1998.0,
      "source": "biogetica"
    },
    "biogetica-pranavita-green-balanced-green-drink-superfood-complex-packed-with-vitamins-and-micro-nutrients-naturally-anti-aging-3-5-oz-100-gm|160 days": {
      "price": 2397.0,
      "compare": 3996.0,
      "source": "biogetica"
    },
    "biogetica-thyrosolve-natural-thyroid-support-80-capsules|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-smokesolve-lungs-detox-anti-nicotin-80-capsule|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-amesolve-secondary-amenorrhoea-support-80-capsules|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-acidsolve-antacid-pro-digestion|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-urisolve-kidney-care-utri-support|default title": {
      "price": 899.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-pilesolve-piles-care-fistula-care|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-livosolve-liver-care|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-prostisolve-prostrate-care|default title": {
      "price": 1299.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-hemosolve-daily-iron-supplement-80-capsules|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-talvaar-2-0-with-ashwagandha-shilajit-safed-musli-horny-goat-weed-extract-stamina-booster-supplements-for-men-30-capsules|30 capsules": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-talvaar-2-0-with-ashwagandha-shilajit-safed-musli-horny-goat-weed-extract-stamina-booster-supplements-for-men-30-capsules|80 capsules": {
      "price": 899.0,
      "compare": 999.0,
      "source": "biogetica"
    },
    "biogetica-aerosolve-lungs-health-oxygenation|default title": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-spectrum-natural-advance-multivitamin|default title": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-circulosolve-vericoveins-supprt-hypertention|default title": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-diasolve-sugar-and-metabolism-support-80-tablets|default title": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-metasolve-cellular-health-and-immune-support-80-tablets|default title": {
      "price": 1299.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-arthrosolve-gouts-arthritis-bone-and-joints-care|default title": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-immunofree-60-tablets-anti-virus-mix-rare-herbs-immunity-booster|30 tablets": {
      "price": 899.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-immunofree-60-tablets-anti-virus-mix-rare-herbs-immunity-booster|60 tablets": {
      "price": 1499.0,
      "compare": null,
      "source": "biogetica"
    },
    "bloom-reginmune-natural-immune-support-care-80-capsules-copy|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-reginmune-natural-immune-support-care-80-capsules|40 days": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "biogetica-reginmune-natural-immune-support-care-80-capsules|80 days": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "biogetica-reginmune-natural-immune-support-care-80-capsules|160 days": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "biogetica-hyperisince-30-tab-anti-herpes|30 tab": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-hyperisince-30-tab-anti-herpes|80 tab": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "hyperisince-80-tablets|40 days": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "hyperisince-80-tablets|80 days": {
      "price": 3198.0,
      "compare": 3998.0,
      "source": "biogetica"
    },
    "hyperisince-80-tablets|160 days": {
      "price": 5997.0,
      "compare": 7996.0,
      "source": "biogetica"
    },
    "biogetica-neuralease-80-tab-trigeminal-neuralgia|40 days": {
      "price": 1274.0,
      "compare": 1499.0,
      "source": "biogetica"
    },
    "biogetica-neuralease-80-tab-trigeminal-neuralgia|80 days": {
      "price": 2248.0,
      "compare": 2998.0,
      "source": "biogetica"
    },
    "biogetica-neuralease-80-tab-trigeminal-neuralgia|160 days": {
      "price": 3597.0,
      "compare": 5996.0,
      "source": "biogetica"
    },
    "biogetica-neurosolve-brain-and-memory|default title": {
      "price": 1299.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-neem-blood-purifying-anti-inflammatory-detox-30-capsules|30 capsules": {
      "price": 299.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-neem-blood-purifying-anti-inflammatory-detox-30-capsules|80 capsules": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-core-immunity-kit-immunofree-and-reginmune-31|default title": {
      "price": 1499.0,
      "compare": 3498.0,
      "source": "biogetica"
    },
    "biogetica-cronisol-d-arthritis-trigeminal-neuralgia-30-capsules|80 capsules": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "biogetica-cronisol-d-arthritis-trigeminal-neuralgia-30-capsules|160 capsules": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "biogetica-bipsolve-high-bp-hypertension-80-tablets|default title": {
      "price": 2399.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-sleepsolve-sleep-support-80-tablets|default title": {
      "price": 1299.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-alclearize-blood-purify|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-alklearant-utri-detox|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-aswagandha-boost-over-all-wellness-30-capsules|30 capsules": {
      "price": 299.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-aswagandha-boost-over-all-wellness-30-capsules|60 capsules": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-hairgrow-advance-hair-support-30-cap|30 capsules": {
      "price": 399.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-hairgrow-advance-hair-support-30-cap|60 capsules": {
      "price": 699.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-hairgrow-advance-hair-support-30-cap|80 capsules": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-hairgrow-essential-kit|default title": {
      "price": 1898.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-stemagrow-stemcell-based-hair-serum-25ml|default title": {
      "price": 1499.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-coliosolve-laxative-and-digestive-support|default title": {
      "price": 1399.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-cholesolve-lipid-metabosilm-care|default title": {
      "price": 899.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-neurorich-enhence-brain-function|default title": {
      "price": 1499.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-gastrosolve-diarrhea-and-digestive-care|default title": {
      "price": 1099.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-leucorrsolve-women-health-and-discharge-support|default title": {
      "price": 1399.0,
      "compare": null,
      "source": "biogetica"
    },
    "visarpaclay|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-detoxym-detoxification|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-drenuril-prostrate-health|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-rinusin-depression-immune-health-fibromyalgia-sciatica|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-prana-mana-depression-immune-health-fibromyalgia-sciatica|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-reguline-m-weight-loss-metabolism|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-euphoria-depression-care|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-arthrose-arthritis-gout-bursitis-care|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-digest-constipation-digestive-disorders-diarrhea-ibs|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-dormisol-insomnia-care|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-equilibrium-tinnitus-trigeminal-neuralgia-immune-health-stress-stop-smoking-bed-wetting|default title": {
      "price": 4888.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-radi-anxiety-depression|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-reginat-cataract-care|default title": {
      "price": 4888.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-aerovent-emphysema-copd-bronchitis-asthma|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-cardivas-high-bp-hypertension|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-cerevitan-parkinsons-alzheimers-dementia|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-endokrium-pcos-menopause-pms-fibroids-hypothyroid-hyperthyroid|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-equilife-body-enery-regulation-immune-health-trigeminal-neuralgia|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-soluban-complete-immune-health|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-soluvin-cellular-immunity|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-agelife-anti-ageing|default title": {
      "price": 6499.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-serenat-insomnia-care|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-vision-conjunctivitis-care|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-sindromet|default title": {
      "price": 6499.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-foodbiotic|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-holoram-enmt|default title": {
      "price": 6499.0,
      "compare": 7148.0,
      "source": "biogetica"
    },
    "biogetica-holoram-neoqrtx|default title": {
      "price": 5999.0,
      "compare": null,
      "source": "biogetica"
    },
    "adhd-kit|40 days": {
      "price": 7197.0,
      "compare": 7997.0,
      "source": "biogetica"
    },
    "adhd-kit|80 days": {
      "price": 13594.0,
      "compare": 15994.0,
      "source": "biogetica"
    },
    "adhd-kit|160 days": {
      "price": 26230.0,
      "compare": 31988.0,
      "source": "biogetica"
    },
    "allergy-balance|40 days": {
      "price": 1797.3,
      "compare": 1997.0,
      "source": "biogetica"
    },
    "allergy-balance|80 days": {
      "price": 7192.8,
      "compare": 9892.8,
      "source": "biogetica"
    },
    "allergy-balance|160 days": {
      "price": 17027.0,
      "compare": 18918.21,
      "source": "biogetica"
    },
    "anemia-kit|40 days": {
      "price": 6747.0,
      "compare": 7497.0,
      "source": "biogetica"
    },
    "anemia-kit|80 days": {
      "price": 12744.0,
      "compare": 14994.0,
      "source": "biogetica"
    },
    "anemia-kit|160 days": {
      "price": 24590.0,
      "compare": 29988.0,
      "source": "biogetica"
    },
    "deliverance-kit-with-om-16-formula|40 days": {
      "price": 5195.0,
      "compare": 5773.0,
      "source": "biogetica"
    },
    "deliverance-kit-with-om-16-formula|80 days": {
      "price": 10168.0,
      "compare": 11546.0,
      "source": "biogetica"
    },
    "deliverance-kit-with-om-16-formula|160 days": {
      "price": 19859.0,
      "compare": 23092.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-ac-nee-200-formula|40 days": {
      "price": 4590.0,
      "compare": 5216.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-ac-nee-200-formula|80 days": {
      "price": 8867.0,
      "compare": 10432.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-ac-nee-200-formula|160 days": {
      "price": 16899.0,
      "compare": 20864.0,
      "source": "biogetica"
    },
    "hair-loss-kit|40 days": {
      "price": 3146.0,
      "compare": 3496.0,
      "source": "biogetica"
    },
    "hair-loss-kit|80 days": {
      "price": 5943.0,
      "compare": 6992.0,
      "source": "biogetica"
    },
    "hair-loss-kit|160 days": {
      "price": 11187.0,
      "compare": 13984.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-9-formula|40 days": {
      "price": 5037.0,
      "compare": 5597.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-9-formula|80 days": {
      "price": 9514.0,
      "compare": 11194.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-9-formula|160 days": {
      "price": 17910.0,
      "compare": 22388.0,
      "source": "biogetica"
    },
    "upper-respiratory-tract-infection-kit|40 days": {
      "price": 4227.3,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "upper-respiratory-tract-infection-kit|80 days": {
      "price": 8107.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "upper-respiratory-tract-infection-kit|160 days": {
      "price": 15383.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "acid-reflux-kit|40 days": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "acid-reflux-kit|80 days": {
      "price": 9674.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "acid-reflux-kit|160 days": {
      "price": 18689.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "bloom-freedom-kit-with-br-factor-mucuna-pruriens-and-neurosolve|40 days": {
      "price": 4767.3,
      "compare": 5797.0,
      "source": "biogetica"
    },
    "bloom-freedom-kit-with-br-factor-mucuna-pruriens-and-neurosolve|80 days": {
      "price": 9854.0,
      "compare": 11594.0,
      "source": "biogetica"
    },
    "bloom-freedom-kit-with-br-factor-mucuna-pruriens-and-neurosolve|160 days": {
      "price": 17026.38,
      "compare": 23188.0,
      "source": "biogetica"
    },
    "deliverance-kit-with-cb7-formula|40 days": {
      "price": 8092.0,
      "compare": 9196.0,
      "source": "biogetica"
    },
    "deliverance-kit-with-cb7-formula|80 days": {
      "price": 15633.0,
      "compare": 18392.0,
      "source": "biogetica"
    },
    "deliverance-kit-with-cb7-formula|160 days": {
      "price": 30162.0,
      "compare": 36784.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-5-circulatory-balance-formula|40 days": {
      "price": 4227.3,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-5-circulatory-balance-formula|80 days": {
      "price": 8107.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-5-circulatory-balance-formula|160 days": {
      "price": 15383.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "alcoholism-kit|40 days": {
      "price": 3996.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "alcoholism-kit|80 days": {
      "price": 7192.8,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "alcoholism-kit|160 days": {
      "price": 18918.21,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "amenorrhea-kit|40 days": {
      "price": 4837.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "amenorrhea-kit|80 days": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "amenorrhea-kit|160 days": {
      "price": 18030.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "freedom-cns-support-kit-with-cp-30-and-equilibrium|40 days": {
      "price": 4813.2,
      "compare": 5162.0,
      "source": "biogetica"
    },
    "freedom-cns-support-kit-with-cp-30-and-equilibrium|80 days": {
      "price": 10194.0,
      "compare": 11994.0,
      "source": "biogetica"
    },
    "freedom-cns-support-kit-with-cp-30-and-equilibrium|160 days": {
      "price": 19190.0,
      "compare": 23988.0,
      "source": "biogetica"
    },
    "athletes-foot-kit|40 days": {
      "price": 5457.0,
      "compare": 6497.0,
      "source": "biogetica"
    },
    "athletes-foot-kit|80 days": {
      "price": 10395.0,
      "compare": 12994.0,
      "source": "biogetica"
    },
    "athletes-foot-kit|160 days": {
      "price": 19750.0,
      "compare": 25988.0,
      "source": "biogetica"
    },
    "back-pain-kit|40 days": {
      "price": 2697.0,
      "compare": 2997.0,
      "source": "biogetica"
    },
    "back-pain-kit|80 days": {
      "price": 5274.0,
      "compare": 5994.0,
      "source": "biogetica"
    },
    "back-pain-kit|160 days": {
      "price": 10309.0,
      "compare": 11988.0,
      "source": "biogetica"
    },
    "deliverance-respiratory-support-kit-with-om2-brc-and-adhathoda-ext|40 days": {
      "price": 5012.0,
      "compare": 5696.0,
      "source": "biogetica"
    },
    "deliverance-respiratory-support-kit-with-om2-brc-and-adhathoda-ext|80 days": {
      "price": 9569.0,
      "compare": 11392.0,
      "source": "biogetica"
    },
    "deliverance-respiratory-support-kit-with-om2-brc-and-adhathoda-ext|160 days": {
      "price": 18227.0,
      "compare": 22784.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-bed-wet-30-formula|40 days": {
      "price": 4066.0,
      "compare": 4621.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-bed-wet-30-formula|80 days": {
      "price": 7763.0,
      "compare": 9242.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-bed-wet-30-formula|160 days": {
      "price": 14787.0,
      "compare": 18484.0,
      "source": "biogetica"
    },
    "bursitis-kit|40 days": {
      "price": 4573.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "bursitis-kit|80 days": {
      "price": 8730.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "bursitis-kit|160 days": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "benign-prostatic-hypertrophy-kit|40 days": {
      "price": 5101.0,
      "compare": 5797.0,
      "source": "biogetica"
    },
    "benign-prostatic-hypertrophy-kit|80 days": {
      "price": 9738.0,
      "compare": 11594.0,
      "source": "biogetica"
    },
    "benign-prostatic-hypertrophy-kit|160 days": {
      "price": 18550.0,
      "compare": 23188.0,
      "source": "biogetica"
    },
    "boils-kit|40 days": {
      "price": 4397.0,
      "compare": 4997.0,
      "source": "biogetica"
    },
    "boils-kit|80 days": {
      "price": 8394.0,
      "compare": 9994.0,
      "source": "biogetica"
    },
    "boils-kit|160 days": {
      "price": 15990.0,
      "compare": 19988.0,
      "source": "biogetica"
    },
    "candida-kit|40 days": {
      "price": 2697.0,
      "compare": 2997.0,
      "source": "biogetica"
    },
    "candida-kit|80 days": {
      "price": 5154.0,
      "compare": 5994.0,
      "source": "biogetica"
    },
    "candida-kit|160 days": {
      "price": 9830.0,
      "compare": 11988.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-4-formula|40 days": {
      "price": 3597.0,
      "compare": 3997.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-4-formula|80 days": {
      "price": 6794.0,
      "compare": 7994.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-4-formula|160 days": {
      "price": 12790.0,
      "compare": 15988.0,
      "source": "biogetica"
    },
    "cirrhosis-of-the-liver-kit|40 days": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "cirrhosis-of-the-liver-kit|80 days": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "cirrhosis-of-the-liver-kit|160 days": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-om-9-crnd-formula|40 days": {
      "price": 5782.0,
      "compare": 6497.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-om-9-crnd-formula|80 days": {
      "price": 10914.0,
      "compare": 12994.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-om-9-crnd-formula|160 days": {
      "price": 20530.0,
      "compare": 25988.0,
      "source": "biogetica"
    },
    "muscle-cramps-kit|40 days": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "muscle-cramps-kit|80 days": {
      "price": 8938.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "muscle-cramps-kit|160 days": {
      "price": 17046.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "chlamydia-infection-kit|40 days": {
      "price": 5846.0,
      "compare": 6496.0,
      "source": "biogetica"
    },
    "chlamydia-infection-kit|80 days": {
      "price": 11043.0,
      "compare": 12992.0,
      "source": "biogetica"
    },
    "chlamydia-infection-kit|160 days": {
      "price": 20787.0,
      "compare": 25984.0,
      "source": "biogetica"
    },
    "full-spectrum-colon-support-kit-with-om-6-colon-formula|40 days": {
      "price": 4925.0,
      "compare": 5597.0,
      "source": "biogetica"
    },
    "full-spectrum-colon-support-kit-with-om-6-colon-formula|80 days": {
      "price": 9291.0,
      "compare": 11194.0,
      "source": "biogetica"
    },
    "full-spectrum-colon-support-kit-with-om-6-colon-formula|160 days": {
      "price": 17462.0,
      "compare": 22388.0,
      "source": "biogetica"
    },
    "cystitis-kit|40 days": {
      "price": 3077.0,
      "compare": 3497.0,
      "source": "biogetica"
    },
    "cystitis-kit|80 days": {
      "price": 5805.0,
      "compare": 6994.0,
      "source": "biogetica"
    },
    "cystitis-kit|160 days": {
      "price": 10910.0,
      "compare": 13988.0,
      "source": "biogetica"
    },
    "corneal-support-freedom-kit-with-vision-and-crt-formula|40 days": {
      "price": 4645.0,
      "compare": 5162.0,
      "source": "biogetica"
    },
    "corneal-support-freedom-kit-with-vision-and-crt-formula|80 days": {
      "price": 8775.0,
      "compare": 10324.0,
      "source": "biogetica"
    },
    "corneal-support-freedom-kit-with-vision-and-crt-formula|160 days": {
      "price": 16518.0,
      "compare": 20648.0,
      "source": "biogetica"
    },
    "full-spectrum-circulatory-support-kit-with-cholesolve-resveratrol-green-tea-and-allium-formula|40 days": {
      "price": 4651.0,
      "compare": 5168.0,
      "source": "biogetica"
    },
    "full-spectrum-circulatory-support-kit-with-cholesolve-resveratrol-green-tea-and-allium-formula|80 days": {
      "price": 8785.0,
      "compare": 10336.0,
      "source": "biogetica"
    },
    "full-spectrum-circulatory-support-kit-with-cholesolve-resveratrol-green-tea-and-allium-formula|160 days": {
      "price": 16537.0,
      "compare": 20672.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-om11-cnj-formula|default title": {
      "price": 898.0,
      "compare": 998.0,
      "source": "biogetica"
    },
    "cellulitis-kit|40 days": {
      "price": 5457.0,
      "compare": 6497.0,
      "source": "biogetica"
    },
    "cellulitis-kit|80 days": {
      "price": 10395.0,
      "compare": 12994.0,
      "source": "biogetica"
    },
    "cellulitis-kit|160 days": {
      "price": 19750.0,
      "compare": 25988.0,
      "source": "biogetica"
    },
    "chronic-fatigue-kit|40 days": {
      "price": 4497.0,
      "compare": 4997.0,
      "source": "biogetica"
    },
    "chronic-fatigue-kit|80 days": {
      "price": 8494.0,
      "compare": 9994.0,
      "source": "biogetica"
    },
    "chronic-fatigue-kit|160 days": {
      "price": 15990.0,
      "compare": 19988.0,
      "source": "biogetica"
    },
    "constipation-kit|40 days": {
      "price": 5130.0,
      "compare": 5897.0,
      "source": "biogetica"
    },
    "constipation-kit|80 days": {
      "price": 9671.0,
      "compare": 11794.0,
      "source": "biogetica"
    },
    "constipation-kit|160 days": {
      "price": 18162.0,
      "compare": 23588.0,
      "source": "biogetica"
    },
    "freedom-cns-support-kit-with-br-200-bacopa-and-cerevitan-formula|40 days": {
      "price": 4178.0,
      "compare": 4643.0,
      "source": "biogetica"
    },
    "freedom-cns-support-kit-with-br-200-bacopa-and-cerevitan-formula|80 days": {
      "price": 7893.0,
      "compare": 9286.0,
      "source": "biogetica"
    },
    "freedom-cns-support-kit-with-br-200-bacopa-and-cerevitan-formula|160 days": {
      "price": 14857.0,
      "compare": 18572.0,
      "source": "biogetica"
    },
    "diarrhea-kit|40 days": {
      "price": 5037.0,
      "compare": 5597.0,
      "source": "biogetica"
    },
    "diarrhea-kit|80 days": {
      "price": 9514.0,
      "compare": 11194.0,
      "source": "biogetica"
    },
    "diarrhea-kit|160 days": {
      "price": 17910.0,
      "compare": 22388.0,
      "source": "biogetica"
    },
    "dental-problems-kit|40 days": {
      "price": 4122.0,
      "compare": 4580.0,
      "source": "biogetica"
    },
    "dental-problems-kit|80 days": {
      "price": 7786.0,
      "compare": 9160.0,
      "source": "biogetica"
    },
    "dental-problems-kit|160 days": {
      "price": 14656.0,
      "compare": 18320.0,
      "source": "biogetica"
    },
    "depression-kit|40 days": {
      "price": 7647.0,
      "compare": 8497.0,
      "source": "biogetica"
    },
    "depression-kit|80 days": {
      "price": 14444.0,
      "compare": 16994.0,
      "source": "biogetica"
    },
    "depression-kit|160 days": {
      "price": 27190.0,
      "compare": 33988.0,
      "source": "biogetica"
    },
    "bloom-freedom-kit-with-db-24-formula|40": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "bloom-freedom-kit-with-db-24-formula|80": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "bloom-freedom-kit-with-db-24-formula|160": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "detoxification-kit|40 days": {
      "price": 5307.0,
      "compare": 5897.0,
      "source": "biogetica"
    },
    "detoxification-kit|80 days": {
      "price": 10024.0,
      "compare": 11794.0,
      "source": "biogetica"
    },
    "detoxification-kit|160 days": {
      "price": 18870.0,
      "compare": 23588.0,
      "source": "biogetica"
    },
    "freedom-kit-with-menses-pain-200-formula|40 days": {
      "price": 3147.0,
      "compare": 3497.0,
      "source": "biogetica"
    },
    "freedom-kit-with-menses-pain-200-formula|80 days": {
      "price": 5944.0,
      "compare": 6994.0,
      "source": "biogetica"
    },
    "freedom-kit-with-menses-pain-200-formula|160 days": {
      "price": 11190.0,
      "compare": 13988.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-skin-h-dry-eczemease-formula|40 days": {
      "price": 5013.0,
      "compare": 5571.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-skin-h-dry-eczemease-formula|80 days": {
      "price": 9470.0,
      "compare": 11142.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-skin-h-dry-eczemease-formula|160 days": {
      "price": 17827.0,
      "compare": 22284.0,
      "source": "biogetica"
    },
    "premature-ejaculation-kit|40 days": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "premature-ejaculation-kit|80 days": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "premature-ejaculation-kit|160 days": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "edema-kit|40 days": {
      "price": 1707.0,
      "compare": 1897.0,
      "source": "biogetica"
    },
    "edema-kit|80 days": {
      "price": 3224.0,
      "compare": 3794.0,
      "source": "biogetica"
    },
    "edema-kit|160 days": {
      "price": 6070.0,
      "compare": 7588.0,
      "source": "biogetica"
    },
    "emphysema-kit|40 days": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "emphysema-kit|80 days": {
      "price": 8834.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "emphysema-kit|160 days": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "endometriosis-kit|40 days": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "endometriosis-kit|80 days": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "endometriosis-kit|160 days": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om24-fbd-endokrium-formula|40 days": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om24-fbd-endokrium-formula|80 days": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om24-fbd-endokrium-formula|160 days": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "frozen-shoulder-kit|40 days": {
      "price": 2608.0,
      "compare": 2898.0,
      "source": "biogetica"
    },
    "frozen-shoulder-kit|80 days": {
      "price": 4926.0,
      "compare": 5796.0,
      "source": "biogetica"
    },
    "frozen-shoulder-kit|160 days": {
      "price": 9273.0,
      "compare": 11592.0,
      "source": "biogetica"
    },
    "gallstones-kit|40 days": {
      "price": 4946.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "gallstones-kit|80 days": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "gallstones-kit|160 days": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "gout-kit|40 days": {
      "price": 7647.0,
      "compare": 8497.0,
      "source": "biogetica"
    },
    "gout-kit|80 days": {
      "price": 14444.0,
      "compare": 16994.0,
      "source": "biogetica"
    },
    "gout-kit|160 days": {
      "price": 27190.0,
      "compare": 33988.0,
      "source": "biogetica"
    },
    "freedom-kit-with-mouth-and-gum-formula|40 days": {
      "price": 2322.0,
      "compare": 2580.0,
      "source": "biogetica"
    },
    "freedom-kit-with-mouth-and-gum-formula|80 days": {
      "price": 4386.0,
      "compare": 5160.0,
      "source": "biogetica"
    },
    "freedom-kit-with-mouth-and-gum-formula|160 days": {
      "price": 8256.0,
      "compare": 10320.0,
      "source": "biogetica"
    },
    "full-spectrum-endocrine-support-kit-with-endokrium-and-hekla-lava|40 days": {
      "price": 4372.0,
      "compare": 4858.0,
      "source": "biogetica"
    },
    "full-spectrum-endocrine-support-kit-with-endokrium-and-hekla-lava|80 days": {
      "price": 8258.0,
      "compare": 9716.0,
      "source": "biogetica"
    },
    "full-spectrum-endocrine-support-kit-with-endokrium-and-hekla-lava|160 days": {
      "price": 15545.0,
      "compare": 19432.0,
      "source": "biogetica"
    },
    "gonorrhea-kit|40 days": {
      "price": 5846.0,
      "compare": 6496.0,
      "source": "biogetica"
    },
    "gonorrhea-kit|80 days": {
      "price": 11043.0,
      "compare": 12992.0,
      "source": "biogetica"
    },
    "gonorrhea-kit|160 days": {
      "price": 20787.0,
      "compare": 25984.0,
      "source": "biogetica"
    },
    "hpv-kit|40 days": {
      "price": 3900.0,
      "compare": 4196.0,
      "source": "biogetica"
    },
    "hpv-kit|120 days": {
      "price": 3900.0,
      "compare": 4196.0,
      "source": "biogetica"
    },
    "freedom-kit-with-homeopathic-bp-formula|40 days": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "freedom-kit-with-homeopathic-bp-formula|80 days": {
      "price": 8834.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "freedom-kit-with-homeopathic-bp-formula|160 days": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "herpes-kit|40 days": {
      "price": 3996.0,
      "compare": 4996.0,
      "source": "biogetica"
    },
    "herpes-kit|80 days": {
      "price": 7192.8,
      "compare": 9992.0,
      "source": "biogetica"
    },
    "herpes-kit|160 days": {
      "price": 13988.0,
      "compare": 19984.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-hy-formula|40 days": {
      "price": 6296.0,
      "compare": 6996.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-hy-formula|80 days": {
      "price": 11893.0,
      "compare": 13992.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-hy-formula|160 days": {
      "price": 22387.0,
      "compare": 27984.0,
      "source": "biogetica"
    },
    "hiatus-hernia-kit|40 days": {
      "price": 4127.0,
      "compare": 4586.0,
      "source": "biogetica"
    },
    "hiatus-hernia-kit|80 days": {
      "price": 7796.0,
      "compare": 9172.0,
      "source": "biogetica"
    },
    "hiatus-hernia-kit|160 days": {
      "price": 14675.0,
      "compare": 18344.0,
      "source": "biogetica"
    },
    "freedom-endocrine-support-kit-with-thyrosolve-and-homeopathic-thyroidium-3x|40 days": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "freedom-endocrine-support-kit-with-thyrosolve-and-homeopathic-thyroidium-3x|80 days": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "freedom-endocrine-support-kit-with-thyrosolve-and-homeopathic-thyroidium-3x|160 days": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "hemorrhoids-kit|40 days": {
      "price": 5047.0,
      "compare": 5608.0,
      "source": "biogetica"
    },
    "hemorrhoids-kit|80 days": {
      "price": 9533.0,
      "compare": 11216.0,
      "source": "biogetica"
    },
    "hemorrhoids-kit|160 days": {
      "price": 17945.0,
      "compare": 22432.0,
      "source": "biogetica"
    },
    "freedom-kit-with-endokrium-diasolve-fbpc-formula|40 days": {
      "price": 5126.0,
      "compare": 5696.0,
      "source": "biogetica"
    },
    "freedom-kit-with-endokrium-diasolve-fbpc-formula|80 days": {
      "price": 9683.0,
      "compare": 11392.0,
      "source": "biogetica"
    },
    "freedom-kit-with-endokrium-diasolve-fbpc-formula|160 days": {
      "price": 18227.0,
      "compare": 22784.0,
      "source": "biogetica"
    },
    "infectious-mononucleosis-kit|40 days": {
      "price": 4047.0,
      "compare": 4497.0,
      "source": "biogetica"
    },
    "infectious-mononucleosis-kit|80 days": {
      "price": 7644.0,
      "compare": 8994.0,
      "source": "biogetica"
    },
    "infectious-mononucleosis-kit|160 days": {
      "price": 14390.0,
      "compare": 17988.0,
      "source": "biogetica"
    },
    "insomnia-kit|40 days": {
      "price": 5217.0,
      "compare": 5797.0,
      "source": "biogetica"
    },
    "insomnia-kit|80 days": {
      "price": 9854.0,
      "compare": 11594.0,
      "source": "biogetica"
    },
    "insomnia-kit|160 days": {
      "price": 18550.0,
      "compare": 23188.0,
      "source": "biogetica"
    },
    "freedom-digestive-support-with-om-9-ib-formula-and-aloe-vera|40 days": {
      "price": 5037.0,
      "compare": 5597.0,
      "source": "biogetica"
    },
    "freedom-digestive-support-with-om-9-ib-formula-and-aloe-vera|80 days": {
      "price": 9514.0,
      "compare": 11194.0,
      "source": "biogetica"
    },
    "freedom-digestive-support-with-om-9-ib-formula-and-aloe-vera|160 days": {
      "price": 17910.0,
      "compare": 22388.0,
      "source": "biogetica"
    },
    "full-spectrum-renal-support-kit-with-reishi-and-punarnava|40 days": {
      "price": 4857.0,
      "compare": 5397.0,
      "source": "biogetica"
    },
    "full-spectrum-renal-support-kit-with-reishi-and-punarnava|80 days": {
      "price": 9174.0,
      "compare": 10794.0,
      "source": "biogetica"
    },
    "full-spectrum-renal-support-kit-with-reishi-and-punarnava|160 days": {
      "price": 17270.0,
      "compare": 21588.0,
      "source": "biogetica"
    },
    "kidney-stone-kit|40 days": {
      "price": 1258.0,
      "compare": 1398.0,
      "source": "biogetica"
    },
    "kidney-stone-kit|80 days": {
      "price": 2376.0,
      "compare": 2796.0,
      "source": "biogetica"
    },
    "kidney-stone-kit|160 days": {
      "price": 4473.0,
      "compare": 5592.0,
      "source": "biogetica"
    },
    "laryngitis-kit|40 days": {
      "price": 2697.0,
      "compare": 2997.0,
      "source": "biogetica"
    },
    "laryngitis-kit|80 days": {
      "price": 5094.0,
      "compare": 5994.0,
      "source": "biogetica"
    },
    "laryngitis-kit|160 days": {
      "price": 9590.0,
      "compare": 11988.0,
      "source": "biogetica"
    },
    "leucorrhea-kit|40 days": {
      "price": 5307.0,
      "compare": 5897.0,
      "source": "biogetica"
    },
    "leucorrhea-kit|80 days": {
      "price": 10024.0,
      "compare": 11794.0,
      "source": "biogetica"
    },
    "leucorrhea-kit|160 days": {
      "price": 18870.0,
      "compare": 23588.0,
      "source": "biogetica"
    },
    "lupus-kit|40 days": {
      "price": 4496.0,
      "compare": 4996.0,
      "source": "biogetica"
    },
    "lupus-kit|80 days": {
      "price": 8493.0,
      "compare": 9992.0,
      "source": "biogetica"
    },
    "lupus-kit|160 days": {
      "price": 15987.0,
      "compare": 19984.0,
      "source": "biogetica"
    },
    "lyme-disease-kit|40 days": {
      "price": 7646.0,
      "compare": 8496.0,
      "source": "biogetica"
    },
    "lyme-disease-kit|80 days": {
      "price": 14443.0,
      "compare": 16992.0,
      "source": "biogetica"
    },
    "lyme-disease-kit|160 days": {
      "price": 27187.0,
      "compare": 33984.0,
      "source": "biogetica"
    },
    "full-spectrum-deliverance-kit-with-climateric-200|40 days": {
      "price": 8133.0,
      "compare": 9037.0,
      "source": "biogetica"
    },
    "full-spectrum-deliverance-kit-with-climateric-200|80 days": {
      "price": 15362.0,
      "compare": 18074.0,
      "source": "biogetica"
    },
    "full-spectrum-deliverance-kit-with-climateric-200|160 days": {
      "price": 28918.0,
      "compare": 36148.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-menorease-formula|40 days": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-menorease-formula|80 days": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-menorease-formula|160 days": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-pn1m-formula|40 days": {
      "price": 3597.0,
      "compare": 3997.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-pn1m-formula|80 days": {
      "price": 6794.0,
      "compare": 7994.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-pn1m-formula|160 days": {
      "price": 12790.0,
      "compare": 15988.0,
      "source": "biogetica"
    },
    "obesity-kit|80 days": {
      "price": 14148.59,
      "compare": null,
      "source": "biogetica"
    },
    "freedom-kit-with-om-3-formula|40 days": {
      "price": 4642.0,
      "compare": 5158.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-3-formula|80 days": {
      "price": 8768.0,
      "compare": 10316.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om-3-formula|160 days": {
      "price": 16505.0,
      "compare": 20632.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-om-8-formula|40 days": {
      "price": 5037.0,
      "compare": 5597.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-om-8-formula|80 days": {
      "price": 9514.0,
      "compare": 11194.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-om-8-formula|160 days": {
      "price": 17910.0,
      "compare": 22388.0,
      "source": "biogetica"
    },
    "parkinsons-disease-kit|40 days": {
      "price": 5473.0,
      "compare": 6082.0,
      "source": "biogetica"
    },
    "parkinsons-disease-kit|80 days": {
      "price": 10339.0,
      "compare": 12164.0,
      "source": "biogetica"
    },
    "parkinsons-disease-kit|160 days": {
      "price": 19462.0,
      "compare": 24328.0,
      "source": "biogetica"
    },
    "pelvic-inflammatory-disease-kit|40 days": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "pelvic-inflammatory-disease-kit|80 days": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "pelvic-inflammatory-disease-kit|160 days": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "peptic-ulcers-kit|40 days": {
      "price": 4947.0,
      "compare": 5497.0,
      "source": "biogetica"
    },
    "peptic-ulcers-kit|80 days": {
      "price": 9344.0,
      "compare": 10994.0,
      "source": "biogetica"
    },
    "peptic-ulcers-kit|160 days": {
      "price": 17590.0,
      "compare": 21988.0,
      "source": "biogetica"
    },
    "premenstrual-syndrome-pms-kit|40 days": {
      "price": 8546.0,
      "compare": 9496.0,
      "source": "biogetica"
    },
    "premenstrual-syndrome-pms-kit|80 days": {
      "price": 16143.0,
      "compare": 18992.0,
      "source": "biogetica"
    },
    "premenstrual-syndrome-pms-kit|160 days": {
      "price": 30387.0,
      "compare": 37984.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-psoraease-formula|40 days": {
      "price": 4448.0,
      "compare": 4943.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-psoraease-formula|80 days": {
      "price": 8403.0,
      "compare": 9886.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-psoraease-formula|160 days": {
      "price": 15817.0,
      "compare": 19772.0,
      "source": "biogetica"
    },
    "freedom-kit-with-hrs-200-scabease-formula|40 days": {
      "price": 729.0,
      "compare": 1020.0,
      "source": "biogetica"
    },
    "freedom-kit-with-hrs-200-scabease-formula|80 days": {
      "price": 1455.0,
      "compare": 2040.0,
      "source": "biogetica"
    },
    "freedom-kit-with-hrs-200-scabease-formula|160 days": {
      "price": 2910.0,
      "compare": 4080.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-sciatic-mix-formula|40 days": {
      "price": 6298.0,
      "compare": 6998.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-sciatic-mix-formula|80 days": {
      "price": 11896.0,
      "compare": 13996.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-sciatic-mix-formula|160 days": {
      "price": 22953.0,
      "compare": 27992.0,
      "source": "biogetica"
    },
    "sinusitis-kit|40 days": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "sinusitis-kit|80 days": {
      "price": 8834.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "sinusitis-kit|160 days": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-mix-59-formula|40 days": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-mix-59-formula|80 days": {
      "price": 8834.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-mix-59-formula|160 days": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "stop-smoking-kit|40 days": {
      "price": 3686.0,
      "compare": 4096.0,
      "source": "biogetica"
    },
    "stop-smoking-kit|80 days": {
      "price": 6963.0,
      "compare": 8192.0,
      "source": "biogetica"
    },
    "stop-smoking-kit|160 days": {
      "price": 13107.0,
      "compare": 16384.0,
      "source": "biogetica"
    },
    "freedom-kit-with-strease-formula|40 days": {
      "price": 4439.0,
      "compare": 4933.0,
      "source": "biogetica"
    },
    "freedom-kit-with-strease-formula|80 days": {
      "price": 8386.0,
      "compare": 9866.0,
      "source": "biogetica"
    },
    "freedom-kit-with-strease-formula|160 days": {
      "price": 15785.0,
      "compare": 19732.0,
      "source": "biogetica"
    },
    "freedom-kit-with-s3-factor-formula|40 days": {
      "price": 2248.0,
      "compare": 2498.0,
      "source": "biogetica"
    },
    "freedom-kit-with-s3-factor-formula|80 days": {
      "price": 4246.0,
      "compare": 4996.0,
      "source": "biogetica"
    },
    "freedom-kit-with-s3-factor-formula|160 days": {
      "price": 7993.0,
      "compare": 9992.0,
      "source": "biogetica"
    },
    "tinnitus-kit|40 days": {
      "price": 4497.0,
      "compare": 4997.0,
      "source": "biogetica"
    },
    "tinnitus-kit|80 days": {
      "price": 8494.0,
      "compare": 9994.0,
      "source": "biogetica"
    },
    "tinnitus-kit|160 days": {
      "price": 15990.0,
      "compare": 19988.0,
      "source": "biogetica"
    },
    "tonsillitis-kit|40 days": {
      "price": 2877.0,
      "compare": 3197.0,
      "source": "biogetica"
    },
    "tonsillitis-kit|80 days": {
      "price": 5434.0,
      "compare": 6394.0,
      "source": "biogetica"
    },
    "tonsillitis-kit|160 days": {
      "price": 10230.0,
      "compare": 12788.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om13-tn-formula|40 days": {
      "price": 3996.0,
      "compare": 4496.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om13-tn-formula|80 days": {
      "price": 7192.8,
      "compare": 8992.0,
      "source": "biogetica"
    },
    "freedom-kit-with-om13-tn-formula|160 days": {
      "price": 13488.0,
      "compare": 17984.0,
      "source": "biogetica"
    },
    "urinary-tract-infection-kit|40 days": {
      "price": 5756.0,
      "compare": 6396.0,
      "source": "biogetica"
    },
    "urinary-tract-infection-kit|80 days": {
      "price": 10873.0,
      "compare": 12792.0,
      "source": "biogetica"
    },
    "urinary-tract-infection-kit|160 days": {
      "price": 20467.0,
      "compare": 25584.0,
      "source": "biogetica"
    },
    "biogetica-deliverance-kit-with-skin-itch-30-utr-formula|40 days": {
      "price": 11427.0,
      "compare": 12697.0,
      "source": "biogetica"
    },
    "biogetica-deliverance-kit-with-skin-itch-30-utr-formula|80 days": {
      "price": 21584.0,
      "compare": 25394.0,
      "source": "biogetica"
    },
    "biogetica-deliverance-kit-with-skin-itch-30-utr-formula|160 days": {
      "price": 40630.0,
      "compare": 50788.0,
      "source": "biogetica"
    },
    "vaginitis-kit|40 days": {
      "price": 5847.0,
      "compare": 6497.0,
      "source": "biogetica"
    },
    "vaginitis-kit|80 days": {
      "price": 11044.0,
      "compare": 12994.0,
      "source": "biogetica"
    },
    "vaginitis-kit|160 days": {
      "price": 20790.0,
      "compare": 25988.0,
      "source": "biogetica"
    },
    "varicose-veins-kit|40 days": {
      "price": 4677.0,
      "compare": 5197.0,
      "source": "biogetica"
    },
    "varicose-veins-kit|80 days": {
      "price": 8834.0,
      "compare": 10394.0,
      "source": "biogetica"
    },
    "varicose-veins-kit|160 days": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "vertigo-kit|40 days": {
      "price": 1527.0,
      "compare": 1697.0,
      "source": "biogetica"
    },
    "vertigo-kit|80 days": {
      "price": 2986.0,
      "compare": 3394.0,
      "source": "biogetica"
    },
    "vertigo-kit|160 days": {
      "price": 5769.0,
      "compare": 6788.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-vitiligease-formula|40 days": {
      "price": 4889.0,
      "compare": 5433.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-vitiligease-formula|80 days": {
      "price": 9236.0,
      "compare": 10866.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-vitiligease-formula|160 days": {
      "price": 17385.0,
      "compare": 21732.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-w-30-formula|40 days": {
      "price": 4048.0,
      "compare": 4498.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-w-30-formula|80 days": {
      "price": 7646.0,
      "compare": 8996.0,
      "source": "biogetica"
    },
    "biogetica-freedom-kit-with-w-30-formula|160 days": {
      "price": 14393.0,
      "compare": 17992.0,
      "source": "biogetica"
    },
    "blood-sugar-balance|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "dprs-balance|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "digestion-balance|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "ear-balance|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "h-factor|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "hair-tonic-6x|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "immunity-cm|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "inflammation-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "kidney-balance|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-2|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-10|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-11-eye|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-12-hair|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-13-trigeminal|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-15|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-16-knees|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-17|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-22|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-25-eye-retina|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-27|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-28|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-31|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-34-parkinson|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-24|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "smokease|default title": {
      "price": 3736.4,
      "compare": null,
      "source": "biogetica"
    },
    "teeth-decay|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "cb-9-200|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "cleansing-mix-6x|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "tn-formula|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "alb-factor|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "br-factor|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "backease-formula|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "drawing-6x|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "g-factor|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "debility-200|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "constipation-200|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "water-balance|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "acidity-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "sleep-cm|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "throat-200|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "sinus-balance|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "meniere-50m|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "tons-6x|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "hp-dspl|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "cold-6x|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "vein-pill-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "ss-pills-200|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "c-factor|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "cca-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "pst-mix|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "eye-200|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "t21-skin-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c40|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c55|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "allersodes-a254-sugar-mix|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t3|default title": {
      "price": 4462.98,
      "compare": null,
      "source": "biogetica"
    },
    "t6-brain-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t-9|default title": {
      "price": 4462.98,
      "compare": null,
      "source": "biogetica"
    },
    "tead-2-t18-pituitary-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c98-c98-anx-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "hmlc-hmlc-muscle-ligament-and-cartilage|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t26-t26-lung-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c33-c33-immune-system-stimulator|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "gastrogest-sgst-gastrogest-w-bitter-herbs-90-tablets|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t10-heart-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "hsd-spinal-sarcode|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "hrd-renal-sarcode|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c5-c5-inflammease|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t26-lung-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t33-prost-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "smcc-mycostat-complex-capsule|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c85-crt-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c5-inflammease|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "x6-immune-stimulator|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c9-stressease|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t15-liver-liquescence-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c18-digestive-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c46-pease-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t6-brain-liquesence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t7-digestive-enzyme-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c3-andi|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c2-ande|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t27-skin-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t14-libido-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t11-homeopathic-diuretic-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "osseoapatite-plus|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "hgb-gall-bladder-mix-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t24-connective-tissue-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t29-immune-enhancement-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c145-immunity-support-hpn-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c32-hrpz|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c132-circulatory-support-hypt|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t31-allergy-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c13-circulation-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "thyc-thyro-complex|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "x17-immune-stimulator|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c93-stomach-enzyme-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t13-kidney-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "vwcm-women-s-multi|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c128-immune-support-ln|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "assist|default title": {
      "price": 4694.45,
      "compare": null,
      "source": "biogetica"
    },
    "sp-8x-pancreatin-8x-plus-45-caplets|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "t19-liquescence|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c59-sct-mix|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c60-respiratory-support-s-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "tpc-pneumo-complex|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c214-tinnitus|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c50-pna-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "c115-vertigease-formula|default title": {
      "price": 4502.84,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-deliverance-kit-with-alb-formula|40 days": {
      "price": 3996.0,
      "compare": 5496.0,
      "source": "biogetica"
    },
    "biogetica-deliverance-kit-with-alb-formula|80 days": {
      "price": 7192.8,
      "compare": 9892.8,
      "source": "biogetica"
    },
    "biogetica-deliverance-kit-with-alb-formula|160 days": {
      "price": 20446.0,
      "compare": 22717.04,
      "source": "biogetica"
    },
    "allergies-kit|40 days": {
      "price": 1797.3,
      "compare": 1997.0,
      "source": "biogetica"
    },
    "ac-nee-200|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "bedwetting-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-cronisol-d-30-capsules|30 capsules": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-cronisol-d-arthritis-trigeminal-neuralgia-30-capsules|40 days": {
      "price": 1699.0,
      "compare": 1999.0,
      "source": "biogetica"
    },
    "biogetica-cronisol-d-arthritis-trigeminal-neuralgia-30-capsules|80 days": {
      "price": 2998.0,
      "compare": 3998.0,
      "source": "biogetica"
    },
    "biogetica-cronisol-d-arthritis-trigeminal-neuralgia-30-capsules|160 days": {
      "price": 4797.0,
      "compare": 7996.0,
      "source": "biogetica"
    },
    "allergy-balance|default title": {
      "price": 1797.3,
      "compare": 1997.0,
      "source": "biogetica"
    },
    "bloom-spiruliva-for-nutrition-that-crosses-the-blood-brain-barrier-160-capsules|default title": {
      "price": 1499.0,
      "compare": null,
      "source": "biogetica"
    },
    "bp-balance-1m|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "cb-7-200|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "climateric-200|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "cp-30-factor|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "crt-compound|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "hpv-kit|default title": {
      "price": 3900.0,
      "compare": 4196.0,
      "source": "biogetica"
    },
    "deliverance-kit-with-phytolacca-30|40": {
      "price": 8137.0,
      "compare": 9042.0,
      "source": "biogetica"
    },
    "deliverance-kit-with-phytolacca-30|40 days": {
      "price": 8137.0,
      "compare": 9042.0,
      "source": "biogetica"
    },
    "weight-loss-kit|40 days": {
      "price": 5014.0,
      "compare": 5572.0,
      "source": "biogetica"
    },
    "fb-factor|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "freedom-kit-with-om13-tn-formula-1|40 days": {
      "price": 3996.0,
      "compare": 4496.0,
      "source": "biogetica"
    },
    "freedom-kit-with-veinpill-varicease-formula-160-days|default title": {
      "price": 16630.0,
      "compare": 20788.0,
      "source": "biogetica"
    },
    "gt-mix-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "hrs-200-scabease-formula|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "hyperisince-80-tablets-copy|default title": {
      "price": 999.0,
      "compare": null,
      "source": "biogetica"
    },
    "kb-factor|default title": {
      "price": 3736.4,
      "compare": null,
      "source": "biogetica"
    },
    "menorease-formula|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "menses-pain-200|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "mouth-gums-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-3|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-4-cervical|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-5-circulation|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-6-colon|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-8-hypo-hyperglycemia|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "om-9-digestive-psychosomatic|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "biogetica-ibs-formula|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "pn-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "psoraease-formula|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "sciatic-mix-10m|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "skin-ich-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "skin-h-dry-eczemease-formula|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "vitiligease-formula|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    },
    "worms-30|default title": {
      "price": 499.0,
      "compare": null,
      "source": "biogetica"
    }
  }
};
